export default class ApiConfig {
    constructor() {
        this.ApiUrl = null;
        this.Name = null;
        this.CacheName = null
        this.reset();
    }

    setValues(ApiUrl, Name, CacheName) {
        this.ApiUrl = ApiUrl;
        this.Name = Name;
        this.CacheName = CacheName;
    }

    reset() {
        this.ApiUrl = 'events?PageSize=40&PageNumber=';
        this.Name = 'Alla evenemang';
        this.CacheName = 'eventsCache';
    }
}